import { AccountNumberParams, managePricingContext } from 'pages/managePricing/managePricingResolver';
import { ROUTES } from 'routing';
import { formatLocalDateToLocalISODateTimeString } from 'shared/utility';
import { DeviationConfirmationRequest } from 'types/backend';
import { TAddedDeviation } from 'types/forms';
import UseDynamicUrl from './useDynamicUrl';
import useSubmitEdit from './useSubmitEdit';

type UseEditDeviationRequestProps = {
    onSuccess?: () => void;
};

export function useEditDeviationRequest({ onSuccess }: UseEditDeviationRequestProps) {
    const { path } = UseDynamicUrl<AccountNumberParams>({ route: ROUTES.managePricing });
    const mapper = (form: TAddedDeviation): DeviationConfirmationRequest => {
        const requestItem: DeviationConfirmationRequest = {
            modelCurrentPrice: {
                ...form.modelCurrentPrice,
                targetPrice: Number(form.modelCurrentPrice.targetPrice),
                price: Number(form.modelCurrentPrice.price),
                currentpriceid: Number(form.modelCurrentPrice.currentpriceid),
                deleted: false,
                effectivestart: new Date().toISOString(), // not used in backend
                lastupdated: undefined,
                effectiveend: undefined,
                status: form.modelCurrentPrice.status,
                startdate: formatLocalDateToLocalISODateTimeString(form.modelCurrentPrice.startdate),
                enddate: formatLocalDateToLocalISODateTimeString(form.modelCurrentPrice.enddate),
            },
            deviationDetails: form.deviationDetails,
            deviationReasonNotes: form.deviationReasonNotes,
        };
        return requestItem;
    };
    const submitRequest = useSubmitEdit({
        mapper,
        name: 'deviation',
        successRoute: path,
        context: managePricingContext,
        onSuccess,
    });

    return submitRequest;
}
